export const MATTER_INTAKE_TEMPLATE_QUESTION_TYPE_OPTIONS = [
  "Multiple Choice",
  "Input",
  "Checkbox",
  "Number",
  "Phone Number",
  "Date",
  "Email",
  "Address",
  "Textarea",
  "File Upload",
] as const;
